

import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { listadoReporteXOPs, listadoReporteXStock } from "../../../services";




export const useListReporteXStock = (id) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');

    const { data, isLoading } = useQuery({
        queryKey: ['reporteXstock', { page, id }], 
        queryFn: () => listadoReporteXStock({ page, id }),
        enabled: !!id
    });

    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);

    return {
        // Estados
        page,
        // Métodos
        chagePage,
        data, isLoading,
    }
}





export const useListReporteXOps = (id) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');

    const { data, isLoading } = useQuery({
        queryKey: ['reporteXop', { page, id }], 
        queryFn: () => listadoReporteXOPs({ page, id }),
        enabled: !!id
    });

    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);

    return {
        // Estados
        page,
        // Métodos
        chagePage,
        data, isLoading,
    }
}
